export class DoctorNotExistsError extends Error {
  constructor() {
    super('Médico não encontrado na base de dados.')
    this.name = 'DoctorNotExistsError'
  }
}
